import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { WindowService } from '@core/window-actions';
import { FlightTrackerCopy } from '@dynamic-components/flight-tracker/types/flight-tracker-copy.type';
import { JbDialogService } from 'jb-component-library';

import { FlightTrackerLeg } from '../../types/flight-tracker-leg.type';
import { FlightTrackerFlight } from '../../types/flight-tracker-result.type';
import { FlightTrackerResultsService } from '../flight-tracker-results.service';
import { FlightTrackerResultsDesktopDialogComponent } from '../flight-tracker-results-desktop-dialog/flight-tracker-results-desktop-dialog.component';
import { FlightTrackerResultsDialogComponent } from '../flight-tracker-results-dialog/flight-tracker-results-dialog.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'jb-flight-tracker-results-connecting',
  templateUrl: './flight-tracker-results-connecting.component.html',
  styleUrls: ['./flight-tracker-results-connecting.component.scss'],
  providers: [FlightTrackerResultsService],
})
export class FlightTrackerResultsConnectingComponent {
  currentTime = new Date();
  isMobile;

  @Input('flightTrackerConnectingResults')
  flightTrackerConnectingResults: FlightTrackerFlight[];
  @Input('departureDate') departureDate;
  @Input() flightTrackerCopy: FlightTrackerCopy;

  leg1: any;
  leg2: any;
  desktopLeg: any;
  showDialog = false;
  showDesktopDialog = false;
  @ViewChildren('connectingFlightButtons')
  connectingFlightButtons: QueryList<ElementRef>;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private windowService: WindowService,
    public dialogService: JbDialogService,
  ) {
    this.windowService.windowSizeChanged.subscribe(size => {
      this.isMobile = !!size.small;
      this.changeDetectorRef.detectChanges();
    });
  }

  openMobileDialog(
    elementIndex: number,
    legOne: FlightTrackerLeg,
    legTwo: FlightTrackerLeg,
  ) {
    if (this.isMobile) {
      const buttons = this.connectingFlightButtons?.toArray();
      buttons?.[elementIndex]?.nativeElement?.focus();

      const componentRef = this.dialogService.openDialog(
        FlightTrackerResultsDialogComponent,
        buttons?.[elementIndex]?.nativeElement,
      );

      componentRef.handleData(
        this.departureDate,
        this.flightTrackerCopy,
        legOne,
        legTwo,
      );
    }
  }

  openLargeDialog(event: Event, leg: FlightTrackerLeg) {
    if (!this.isMobile) {
      const componentRef = this.dialogService.openDialog(
        FlightTrackerResultsDesktopDialogComponent,
        event.target,
      );

      componentRef.handleData(this.departureDate, leg);
    }
  }
}
